import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { DocumentClient } from "../../parentApi";

export default new DocumentClient(app_uri, axiosClient());
